import { render, staticRenderFns } from "./documentWorkspace.vue?vue&type=template&id=298f254b&"
import script from "./documentWorkspace.vue?vue&type=script&lang=js&"
export * from "./documentWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298f254b')) {
      api.createRecord('298f254b', component.options)
    } else {
      api.reload('298f254b', component.options)
    }
    module.hot.accept("./documentWorkspace.vue?vue&type=template&id=298f254b&", function () {
      api.rerender('298f254b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/document/documentWorkspace.vue"
export default component.exports